const TxpDataPointNames = {
    // name for datapoint which logs TXP loading end state.
    TXPCardLoading: 'TXPCardLoading',

    //name for datapoint which logs Txp Feedback.
    TXPUserVoice: 'TXP_UserVoice',

    //name for datapoint which logs Txp Error card.
    TXPErrorCard: 'TXPErrorCard',
};

export default TxpDataPointNames;
